import { DefaultAdminPage, DefaultUserPage } from '../config';
import { MENU_ROUTE_PERMISSIONS } from '../constants/menuPermissions';
import { UserMenus } from '../modules/layout/sidebar/menus/user';
import { normalizeLoginType } from './auth';
import {
  getMenuPermissions,
  getUserPermissions,
  hasAnyPermission,
  hasFullAccess,
  isStaffRestrictedUser,
  isTenantSubUser,
  shouldSyncPermissionsOnLoad,
} from './permissions';

const ACCESS_DENIED_ROUTE = '/access-denied';

const canAccessRoute = (routeKey, userData, permissionsOverride = null) => {
  const required = MENU_ROUTE_PERMISSIONS[routeKey];
  if (!required?.length) return true;

  if (
    shouldSyncPermissionsOnLoad(userData) &&
    permissionsOverride !== null &&
    Array.isArray(permissionsOverride)
  ) {
    return hasAnyPermission(getMenuPermissions(userData, permissionsOverride), required);
  }

  if (isTenantSubUser(userData) && !hasFullAccess(userData)) {
    return hasAnyPermission(getMenuPermissions(userData), required);
  }

  if (hasFullAccess(userData)) return true;

  return hasAnyPermission(getUserPermissions(userData), required);
};

const collectMenuRouteKeys = (menus) => {
  const keys = [];

  for (const menu of menus) {
    if (menu.children?.length) {
      for (const child of menu.children) {
        keys.push(child.key);
      }
    } else {
      keys.push(menu.key);
    }
  }

  return keys;
};

export const getFirstAvailableUserRoute = (userData, permissionsOverride = null) => {
  if (!userData) return ACCESS_DENIED_ROUTE;

  if (hasFullAccess(userData) && !shouldSyncPermissionsOnLoad(userData)) {
    return DefaultUserPage;
  }

  const routeKeys = collectMenuRouteKeys(UserMenus);

  for (const routeKey of routeKeys) {
    if (canAccessRoute(routeKey, userData, permissionsOverride)) {
      return `/${routeKey}`;
    }
  }

  return ACCESS_DENIED_ROUTE;
};

export const getDefaultUserRoute = (userData, permissionsOverride = null) =>
  getFirstAvailableUserRoute(userData, permissionsOverride);

export const getPostLoginRoute = (loginType, userData) => {
  const normalizedType = normalizeLoginType(loginType);

  if (normalizedType === 'admin') {
    return DefaultAdminPage;
  }

  if (normalizedType === 'user') {
    if (isStaffRestrictedUser(userData)) {
      return getFirstAvailableUserRoute(userData);
    }
    return DefaultUserPage;
  }

  return '/sign-in';
};
